export default __webpack_public_path__ + "static/media/GR4 2A-1B-1D-2EC.78e8b8f2.jpg";